var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes['light'].background })},[(_vm.$route.name !== 'login')?_c('BasicLayout',[_c('router-view',{key:_vm.$route.fullPath})],1):_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }